import * as zod from "zod";

export const filterSearchVirtualTourSchema = zod.object({
  keyword: zod.coerce.string(),
});

export type FilterSearchVirtualTourFormData = zod.infer<
  typeof filterSearchVirtualTourSchema
>;
